module.exports = __webpack_public_path__ + "static/media/logo-full.ff073b0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/logo-full.svg
// module id = 252
// module chunks = 0